import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../../servicios/api.service'
import * as moment from 'moment';

declare var google;
declare var grecaptcha;
@Component({
  selector: 'app-formulario-contacto',
  templateUrl: './formulario-contacto.component.html',
  styleUrls: ['./formulario-contacto.component.scss']
})

export class FormularioContactoComponent implements OnInit {
  @Input('destinatarios') mostrarDestinatarios: boolean;
  public contactMessage: {
    show: boolean,
    class: string,
    message: string
  } = {
      show: false,
      class: '',
      message: ''
    }
  lockSubmitButton: boolean;
  // areas: any;
  directorio: any;
  private listaEmailsValidos: string[] = [];
  public idAreaSeleccionada = '';
  public destinatarioSeleccionado = '';

  destinatarios: any;

  constructor(private _api: ApiService) { }

  ngOnInit() {
    this.iniciarForm();
    this.obtenerDestinatarios();
    // if (this.mostrarDestinatarios) {
    //   this.obtenerAreas();
    // }
  }

  private obtenerDestinatarios() {
    this._api.get('contactoDestinatarios').subscribe((res: any) => {
      this.destinatarios = this._api.reader.read(res);
    })
  }

  // private obtenerAreas() {
  //   this._api.get('areas').subscribe((res: any) => {
  //     this.areas = this._api.reader.read(res);
  //   })
  // }

  public traerDirectorioArea(idArea) {
    this._api.get(`directorioPorArea/${idArea}`).subscribe((res: any) => {
      this.directorio = this._api.reader.read(res, []).filter(item => {
        if (item.email && item.email != '') {
          this.listaEmailsValidos.push(item.email);
          return item;
        }
      });
    })
  }

  public iniciarForm() {
    //Contact Form Submit Button Disabled
    $('.jsSubmit_button input, .jsSubmit_button textarea').on('keyup', function () {
      var isEmpty = false;
      $('.jsSubmit_button [required]').not('.home-1 .jsSubmit_button [required]').each(function () {
        if ($(this).val() == "") {
          isEmpty = true;
        }
      });
      if (isEmpty) {
        $('.jsSubmit_button button[type="submit"]').attr('disabled', 'disabled');
      } else {
        $('.jsSubmit_button button[type="submit"]').removeAttr('disabled');
      }
    });
  }

  /**
   * Muestra un mensaje debajo del formualrio de contacto
   * y lo oculta después de determinado tiempo
   * El tiempo por defecto es de 3 seg.
   * @param clase establece el estilo del texto
   * @param text es el texto que debe mostrar
   * @param show permite mostrar u ocultar el mensaje
   * @param time opcional el tiempo que quiere que se muestre el mensaje en ms
   */
  private setContactMessage(clase: string, text: string, show: boolean, time?: number) {
    this.contactMessage.show = false;
    this.contactMessage.class = clase;
    this.contactMessage.message = text;
    this.contactMessage.show = show;
    if (show) {
      setTimeout(() => {
        this.contactMessage.show = false;
      }, time || 3000);
    }
  }

  private validarFormulario() {
    if (this.mostrarDestinatarios) {
      // if (this.idAreaSeleccionada && this.idAreaSeleccionada != '' && this.destinatarioSeleccionado && this.destinatarioSeleccionado != '') {
      if (this.destinatarioSeleccionado && this.destinatarioSeleccionado != '') {
        // if (this.listaEmailsValidos.indexOf(this.destinatarioSeleccionado) >= 0) {
        // if (this.destinatarioSeleccionado > 0) {
        return true;
        // } else {
        //   this.setContactMessage('bg-danger', 'El destinatario seleccionado no es válido', true);
        //   return false;
        // }
      } else {
        this.setContactMessage('bg-danger', 'Seleccione al destinatario', true);
        return false;
      }

    } else {
      return true;
    }
  }


  public enviarMensaje(form) {
    let datos = form.value;
    datos.fecha = moment().format('YYYY-MM-DD');
    datos.hora = moment().format('HH:mm:ss');
    datos.comentario = datos.mensaje;
    datos.idUsuario = datos.destinatarios_select;
    if (form.valid && this.validarFormulario()) {
      if (this.mostrarDestinatarios) {
        form.value.destinatario = true;
      }
      this._api.post('guardarMensaje', datos).subscribe(resp => {
        // console.log(resp);
      });
      this.lockSubmitButton = true;
      grecaptcha.execute('6LdY1IMUAAAAABudyu6NYUy0DWSkpx2DPIkmt0hR', { action: 'contacto_destinatarios' })
        .then((token) => {
          // Verify the token on the server.
          this._api.post('verifyCaptcha', { token }).subscribe(result => {
            let respuestaCaptcha = this._api.reader.read(result);
            if (respuestaCaptcha.score > 0.5) {
              // Validar el mensaje y el token de la página(o valida rel token en el servidor)
              this._api.post('email', form.value).subscribe(response => {
                form.resetForm();
                let mailResponse = this._api.reader.read(response, {});
                if (mailResponse.accepted && mailResponse.accepted.length && mailResponse.messageId && mailResponse.messageId != '') {
                  this.setContactMessage('bg-success', 'Se ha enviado su mensaje', true);
                } else if (mailResponse.rejected.length) {
                  this.setContactMessage('bg-danger', 'No se ha podido enviar su mensaje. Intente de nuevo.', true);
                }
                this.lockSubmitButton = false;
              })
            } else {
              this.lockSubmitButton = false;
              grecaptcha.reset();
            }
          })
        });
    }
  }
}
